import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const extensionIcons = {
  pdf: "/icons/pdf.png",
  jpg: "/icons/image.png",
  jpeg: "/icons/image.png",
  png: "/icons/image.png",
  gif: "/icons/image.png",
  mp4: "/icons/video.png",
  mov: "/icons/video.png",
  zip: "/icons/zip.png",
  rar: "/icons/zip.png",
  mp3: "/icons/audio.png",
  wav: "/icons/audio.png",
  txt: "/icons/file.png",
  xls: "/icons/file.png",
  xlsx: "/icons/file.png",
  doc: "/icons/file.png",
  docx: "/icons/file.png",
};

const getIcon = (fileName) => {
  const ext = fileName?.split(".").pop()?.toLowerCase();
  console.log("File extension:", ext, fileName);
  return extensionIcons[ext] || "/icons/file.png";
};

const RepresentativeDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) return;

    const fetchDocuments = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Representative/${currentUser.id}/documents`
        );
        const data = await res.json();
        setDocuments(data);
      } catch (err) {
        console.error("Erreur fetch documents:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [currentUser]);

  return (
    <div className="p-4 text-primary">
      <button
        onClick={() => navigate(-1)}
        className="btn bg-primary text-white rounded-full flex items-center gap-2 mb-4"
      >
        <ArrowLeftIcon className="w-5 h-5" />
        {t("global.back")}
      </button>

      <h1 className="text-xl font-semibold mb-4 ml-4">Mes documents</h1>
      {!currentUser && <p className="ml-4">Veuillez vous connecter.</p>}
      {loading && <p className="ml-4">Chargement des documents...</p>}
      {!documents.length && <p className="ml-4">Aucun document disponible.</p>}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {documents.map((doc, index) => (
          <a
            key={index}
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center border rounded-lg p-3 hover:shadow-md transition"
          >
            <img
              src={getIcon(doc.fileName)}
              alt="icon"
              className="w-16 h-16 mb-2 object-contain"
            />
            <p className="text-center text-sm font-medium truncate ">
              {doc.fileName}
            </p>
            <p className="text-muted text-xs text-gray-500 mt-1">
              {new Date(doc.uploadedAt).toLocaleDateString("fr-CA", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default RepresentativeDocuments;
